import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import classToggle from '../helpers/class-toggle';
import Swiper from 'swiper/bundle';

export default ()=>{
    gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);
    getHeroFrames();

    const hero = document.querySelector('.home-hero');
    const wrapper = document.querySelector('#fullpage');
    const frames = document.querySelectorAll('.home-hero__frame');
    const title = document.querySelector('.home-hero__text');
    const scrollText = document.querySelector('.my-bl-scroll-txt');
    let slider;
    const body = document.body;
    const footer = document.querySelector('.footer');
    const footerWrapper = document.querySelector('.footer-wrapper');

    const activeFrameClass = 'home-hero__frame--visible';
    const sliderPrefix = 'home-slider';
    const sliderEl = document.querySelector(`.${sliderPrefix}`);

    let videos = document.querySelectorAll('.js-video-sound');
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: wrapper,
        start: 'top top',
        end: (window.innerWidth >= 783 )?`+=${innerHeight*2}`:`+=${innerHeight}`,
        pin: hero,
        scrub: true,
        onUpdate: (self) => {
          let progress = self.progress;
          if (frames.length) {
              let frame = Math.round(self.progress * (frames.length - 1));
              classToggle(frames, frames[frame], activeFrameClass);
          }
        },
      }
    });

    tl.to(title, {
        opacity: 1,
        duration: 0.5
    }, 1)

    const tl2 = gsap.timeline({
      scrollTrigger: {
        trigger: wrapper,
        start: 'top top',
        end: `+=200px`,
        scrub: true,
      }
    });
    tl2.to(scrollText, {
        opacity: 0,
        duration: 1,
    }, 1);

    ScrollTrigger.matchMedia({
      "(min-width: 1025px)": function() {
        ScrollTrigger.create({
          trigger: hero,
          start: "top top",
          end: 'bottom 0.1%',
          onEnterBack: () => {
            moveTo(hero);
          },
        });

        let snapeEls = document.querySelectorAll('.js-scroll-snap');

        snapeEls.forEach((section,index) => {
            ScrollTrigger.create({
              trigger: section,
              start: 'top bottom',
              end: 'bottom top+=1',
              onEnter: () => {
                moveTo(section)
              },
              onEnterBack: () => {
                moveTo(section)
              },
            });
        });
      }
    });
    
    function moveTo(element) {
      gsap.set(body, {'overflow': 'hidden'});
      const TIME = 2;

      gsap.to(window, {
        scrollTo: {y: element, autoKill: false},
        duration: TIME,
        onComplete: () => {
            gsap.set(body, {'overflow': 'auto'});
        },
      });
    }

    function getHeroFrames(){
        let imagesContainer = document.querySelector('.home-hero__frames');

        if(!images_object && !imagesContainer){
            return;
        }

        for (let key in images_object) {
            let imgUrl = images_object[key];
            let newImg = document.createElement("IMG");
            newImg.src = imgUrl;
            newImg.classList.add('home-hero__frame');
            if(key === 1){
                newImg.classList.add('home-hero__frame--visible');
            }
            imagesContainer.appendChild(newImg);
        }

    }
}

